import React, { memo } from "react";
import Dialog from "@material-ui/core/Dialog";

// assets
import CloseIcon from "bodycodi/cmap/app/svg/alert_close_icon.svg";

// styles
import "bodycodi/cmap/app/css/common/imageUploadAlert.css";

const ImageUploadAlert = ({ open, setOpen, header, body, onChange }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="alert-pop"
      classes={{ paper: "image-upload-alert" }}
    >
      <div className="image-upload-alert-header">
        <img src={CloseIcon} onClick={handleClose} />
        <span>{header}</span>
      </div>
      <div className="image-upload-alert-body">{body}</div>
      <label className="image-upload-alert-button">
        이미지 설정
        <input hidden type="file" accept="image/*" onChange={onChange} />
      </label>
    </Dialog>
  );
};

export default memo(ImageUploadAlert);
